export default __webpack_public_path__ + "static/welcomBg-d6daeac371123432b89ae18393d79ff6.jpg";